import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumCompanyType, EnumCompanyTypeOption } from "./EnumCompanyType";

/**
 * 公司类型分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemCompanyType extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 类型
     */
    Type?: EnumCompanyType;
    /**
     * 中文名称
     */
    NameZh?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 全名
     */
    Name?: string;
    /**
     * 代码
     */
    Code?: string;
    /**
     * 备注
     */
    Remark?: string;
}

/**
 * 公司类型分页列表-项-表单校验
 */
export const DtoListItemCompanyTypeRules = {
}

/**
 * 公司类型分页列表-项-设置项
 */
export const DtoListItemCompanyTypeMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "Type",
    Label: "类型",
    Pipe: EnumPipe.Enum,
    Options: EnumCompanyTypeOption,
  },
  {
    Prop: "NameZh",
    Label: "中文名称",
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
  },
  {
    Prop: "Name",
    Label: "全名",
  },
  {
    Prop: "Code",
    Label: "代码",
  },
  {
    Prop: "Remark",
    Label: "备注",
  },
]
